import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog";
import { useQuery, useQueryClient } from "react-query";
import { getImageListByMenu } from "services/api/ImageList";
import ImageManagerImages from "./modules/ImageManagerImages";

export default function DialogMenuImageManager({ open, menu, actionClose, setImageSelected }) {
  const queryClient = useQueryClient()
  const [selectedImageCategory, setSelectedImageCategory] = useState(null)
  const [imageList, setImagesList] = useState(null)
  const [selectedImageList, setSelectedImageList] = useState([])
  const [disableMainButtons, setDisableMainButtons] = useState(false)
  const { refetch: refetchIL, data: dataImageList } = useQuery(['imageList', selectedImageCategory],
    () => getImageListByMenu(selectedImageCategory), { refetchOnWindowFocus: false, enabled: selectedImageCategory !== null }
  )

  useEffect(() => {
    if (open) {
      console.log(menu)
      setSelectedImageCategory(menu)
    }
  }, [open])

  useEffect(() => {
    if (dataImageList !== undefined && dataImageList !== null && dataImageList !== "")
      setImagesList(dataImageList.data)
  }, [dataImageList])

  const handleCloseDialogImageManager = () => {
    setSelectedImageCategory(null)
    setSelectedImageList([])
    setImagesList(null)
    actionClose(false)
  }

  const handleRefresData = () => { queryClient.invalidateQueries('imageCategoriesList') }

  const handleResetActions = (action) => {
    if (action === "addImageList") refetchIL()
    if (action === "removeImageList") refetchIL()
  }

  const handleWatchAction = (action, cancel, error, success) => {
    if (cancel) return;
    if (!success) { alert(error.message) } else {
      handleRefresData(); handleResetActions(action)
    }
  }

  const handleReturnImageSelected = () => {
    setImageSelected(selectedImageList[0].url)
    handleCloseDialogImageManager()
  }

  const handleSelectedImageList = (image, type) => { //type: 0=one 1=multiple 2=clear
    switch (type) {
      case 0:
        selectedImageList.length > 0 && selectedImageList[0].id === image.id ?
          setSelectedImageList([]) :
          setSelectedImageList([image])
        break;
      case 1:
        const check = selectedImageList.findIndex(i => i._id === image._id)
        if (selectedImageList.length > 0 && check !== -1) {
          const temp = [...selectedImageList]
          temp.splice(check, 1)
          setSelectedImageList(temp)
        }
        if (selectedImageList.length > 0 && check === -1) {
          setSelectedImageList([...selectedImageList, image])
        }
        break;
      case 2:
        setSelectedImageList(image)
        break;
      default:
        break;
    }
  }

  //if (error) return <div> Ha ocurrido un error </div>

  const Actions = () => (<>
    <Button onClick={handleCloseDialogImageManager} disabled={disableMainButtons} >Cerrar</Button>
    {selectedImageList && selectedImageList.length === 1 && <Button onClick={handleReturnImageSelected} variant="contained" disabled={disableMainButtons}>Establecer imagen</Button>}
  </>)

  return (<>
    <FlexibleWidthDialog
      maxWidth="lg"
      title="Biblioteca de imágenes del menu"
      open={open}
      actions={<Actions />}
    >
      <div className="im-main-container">
        {(selectedImageCategory !== null && imageList !== null) &&
          <div className="im-image-categories-container">
            <ImageManagerImages
              menu={menu}
              imageCategory={selectedImageCategory}
              dataImageList={imageList}
              selectedImageList={selectedImageList}
              setSelectedImageList={handleSelectedImageList}
              setDisableMainButtons={setDisableMainButtons}
              reportAction={handleWatchAction}
            />
          </div>}
      </div>
    </FlexibleWidthDialog>
  </>)
}